import {
  MenuAvailabilityModeSchema,
  type MenuAvailabilityMode as GeneratedMenuAvailabilityMode
} from '~/services/api/generated'

export type MenuAvailabilityMode = GeneratedMenuAvailabilityMode

export const MenuAvailabilityMode = {
  SYNC: MenuAvailabilityModeSchema.enum.sync,
  CUSTOM: MenuAvailabilityModeSchema.enum.custom
} satisfies Record<string, GeneratedMenuAvailabilityMode>

export const MenuAvailabilityModeValues: readonly GeneratedMenuAvailabilityMode[] = [
  MenuAvailabilityModeSchema.enum.sync,
  MenuAvailabilityModeSchema.enum.custom
]
